import { gql } from "@apollo/client";

export const DELETE_POLICY = gql`
  mutation DeletePolicy($input: PolicyDeleteInput!) {
    deletePolicy(input: $input)
  }
`;
